/**
 * Created by Administrator on 2017/10/30.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { FileUpload } from "../service/file-upload";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var alertify: any;
declare var $: any;
@Component({
  templateUrl: './informMessageEdit.html',
  styleUrls: ["./informMessageEdit.component.css"],
})

export class InformMessageEdit implements OnInit {


  constructor(
    private fileUpload: FileUpload,
    private route: ActivatedRoute,
    private http: HttpService,
    private location: Location,
    private domSanitizer: DomSanitizer
  ) { }

  private data: any = {
    'id': '',
    "titleEn": "",
    "titleTc": "",
    "active": 0,
    "startTime": "",
    "endTime": "",
    "contentTc": "",
    "contentEn": "",
    "messageType": "",
    "noticeType": "",
    "discountsType": "",
    "subTitleEn": "",
    "subTitleTc": "",
    "iconEn": "",
    "iconTc": "",
    "mediaType": '0',
    "mediaEn": "",
    "mediaTc": ""
  }

  private imagePath: string = '';
  private isCreate: boolean = false;
  private language = 'tc';
  private messageData: Array<any> = []
  private noticeData: Array<any> = []
  private discountsData: Array<any> = []

  private showIconEn: boolean = false;
  private showIconTc: boolean = false;
  private showMediaEn: boolean = false;
  private showMediaTc: boolean = false;
  private tempPath: string = API.getTemp;
  private upload(name: string) {
    let self = this;
    this.fileUpload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case 'iconEn': self.showIconEn = true; break;
          case 'iconTc': self.showIconTc = true; break;
          case 'mediaEn': self.showMediaEn = true; break;
          case 'mediaTc': self.showMediaTc = true; break;
        }
        self.data[name] = temRes.data.fileName;
      } else {
        alert(temRes.status.message);
      }
    });
  }
  private changeMediaType(type: string): void {
    this.data.mediaType = type;
    if (this.language == 'en') {
      this.data.mediaEn = '';
    } else {
      this.data.mediaTc = '';
    }
  }
  private videoUrl: any;
  private videoUrl3: any;
  private isLocalhost: any = {
    mediaEn: false,
    mediaTc: false,
  }
  private mediaTemp: any = {
    mediaEn: '',
    mediaTc: '',
  };

  private getVideoUrl(mediaUrl, type): any {
    this.isLocalhost[type] = false;
    if (mediaUrl.indexOf('www.youtube.com/embed') == -1 && mediaUrl.indexOf('youtu') != -1) {
      let url;
      if (mediaUrl.indexOf('www.youtube.com/watch') != -1) {
        url = mediaUrl.replace('watch?v=', 'embed/')
        if (mediaUrl.indexOf("&") != -1) {
          url = url.substring(0, mediaUrl.indexOf('&') - 2);
        }
      } else if (mediaUrl.indexOf('youtu.be') != -1) {
        url = mediaUrl.replace('youtu.be', 'www.youtube.com/embed');
      }
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    } else if (mediaUrl.indexOf(location.hostname) != -1
      || mediaUrl.indexOf('localhost') != -1
      || mediaUrl.indexOf('api.naturally-plus.com.tw') != -1
      || mediaUrl.indexOf('s3-ap-northeast-1.amazonaws.com') != -1

    ) {

      this.isLocalhost[type] = true;
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    } else if (mediaUrl.indexOf('www.youtube.com/embed') != -1) {

      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    }
    else {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    }

  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.data.id = params['id'];
    });
    this.getType();
    if (this.data.id != 0) {
      this.getPath();
    } else {
      this.isCreate = true;
    }
    let self = this;
    $("#startTime")
      .datetimepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd hh:ii:ss",
        todayBtn: 1,
        autoclose: true,
      })
      .on("changeDate", function (ev) {
        $("#endTime").datetimepicker("setStartDate", $("#startTime").val());
        self.data.startTime = $(this).val();
      });
    $("#endTime")
      .datetimepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd hh:ii:ss",
        todayBtn: 1,
        autoclose: true,
        // startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
      })
      .on("changeDate", function (ev) {
        $("#startTime").datetimepicker("setEndDate", $("#endTime").val());
        self.data.endTime = $(this).val();
      });
  }

  private showByLanguage(type: string) {
    this.language = type;
  }

  private getPath(): void {
    this.http.getData(API.resourcePath)
      .then(res => {
        this.imagePath = res.data;
        this.getData();
      })
  }
  private getData(): void {
    this.http.getData(API.getNoticeAndDiscountsDetail + '/' + this.data.id).then(res => {
      this.data = res.data;
      this.videoUrl = this.getVideoUrl(this.data.mediaEn, 'mediaEn');
      this.videoUrl3 = this.getVideoUrl(this.data.mediaTc, 'mediaTc');

      this.mediaTemp.mediaEn = this.data.mediaEn1;
      this.mediaTemp.mediaTc = this.data.mediaTc1;
    })
  }
  private getType(): void {
    this.http.getData(API.getNoticeAndDiscountsDetailType).then(res => {
      this.messageData = res.data.messageData;
      this.noticeData = res.data.noticeData;
      this.discountsData = res.data.discountsData;
    })
  }

  private submit(): void {
    this.http.postData(API.noticeAndDiscounts, this.data).then(res => {
      if (res.status.code == 0 || res.status.code == '0') {
        this.location.back();
        alertify.success(res.status.message);
      } else {
        alertify.error(res.status.message);
      }
    });
  }

  ngDoCheck() {
    if (this.mediaTemp.mediaEn != this.data.mediaEn) {
      this.mediaTemp.mediaEn = this.data.mediaEn;
      this.videoUrl = this.getVideoUrl(this.data.mediaEn, 'mediaEn');
    }
    if (this.mediaTemp.mediaTc != this.data.mediaTc) {
      this.mediaTemp.mediaTc = this.data.mediaTc;
      this.videoUrl3 = this.getVideoUrl(this.data.mediaTc, 'mediaTc');
    }
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/message/informMessageEdit.component.ts